import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=0c277d49&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=0c277d49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c277d49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c277d49')) {
      api.createRecord('0c277d49', component.options)
    } else {
      api.reload('0c277d49', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=0c277d49&scoped=true&", function () {
      api.rerender('0c277d49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SxFmMHyzlaAY/JS/teamMember.vue"
export default component.exports